(ns dashboard.effects
  (:require [re-frame.core :as rf]
            [reitit.frontend.easy :as rfe]
            [reitit.frontend.controllers :as rfc]
            [reitit.frontend.history :as rfh]
            [dashboard.common :as common]
            [malli.core :as m]
            [malli.transform :as mt]))

(rf/reg-fx
  ::fx-redirect
  (fn fx-redirect [[view-name params query]]
    (rfe/push-state view-name
                    params
                    query)))

(rf/reg-fx
  ::fx-timeout
  (fn fx-timeout [{:keys [timeout-fn timeout]}]
    (js/setTimeout timeout-fn
                   timeout)))

; XXX: Lifted from Reitit as we want to navigate based on the URL path not
; the view name and other args. [Vesa M.]
(defn- push-state-by-path
  [path]
  ;; pushState does not trigger popstate event so call on-navigate manually
  (.pushState js/window.history nil "" (rfh/-href @rfe/history path))
  (rfh/-on-navigate @rfe/history path))

(defn fx-navigate [{:keys [db]} [_ match]]
  (let [user-roles     (get-in db [:user :roles])
        route-allowed? (common/roles-are-allowed? user-roles match)
        old-match      (:route db)
        state          (get-in match [:query-params :state])]
    (if route-allowed?
      ;; Set the route match if route is allowed.
      (let [new-match (assoc match :controllers (rfc/apply-controllers (:controllers old-match) match))
            new-match (if-let [parameters-schema (-> match :data :parameters)]
                        (update new-match :parameters #(m/decode parameters-schema % mt/string-transformer))
                        new-match)]
        {:db (assoc db :route new-match)})
      ;; If route not allowed

      (cond
       ;; User is authenticated on the login page with a redirect target.
       ;; This can happen for instance when the user has logged in in another
       ;; tab after a logout from multiple ones before.
       (and (contains? user-roles "authenticated")
            (= :route.view/login (get-in match [:data :name]))
            state)
       (let [url (js/URL. (js/decodeURIComponent state))]
         ;; XXX: Not at all sure if the query bit will work with
         ;; `push-state-by-path`. [Vesa M.]
         (push-state-by-path (str (.-pathname url) (.-search url))))

       ;; User is authenticated, redirect to home
       (contains? user-roles "authenticated")
       {::fx-redirect [:route.view/home]}

       ;; User is not authenticated, redirect to login page with current
       ;; page as target
       :else
       {::fx-redirect [:route.view/login
                       nil
                       {:mode (get-in match [:query-params :mode])
                        :state (js/encodeURIComponent
                                (.. js/window -location))}]}))))

(rf/reg-event-fx
  ::navigate
  fx-navigate)

;; when window.location is assigned to a
;; URL that has content disposition set to
;; attachment this will prompt the save file prompt
;; -> works with s3 signed urls

(rf/reg-fx
  ::fx-prompt-file-download
  (fn [url]
    (.assign js/window.location url)))
